var m = require('mithril');

module.exports = {
  view: function (vnode) {
    var attrs = vnode && vnode.attrs ? vnode.attrs : {};
    var tabs = Array.isArray(attrs.tabs) ? attrs.tabs : [];
    var activeKey = attrs.activeKey;
    var onSelect = typeof attrs.onSelect === 'function' ? attrs.onSelect : function () {};
    var className = attrs.className || 'flex items-center';

    return m('div', { class: className }, tabs.map(function (tab, index) {
      var normalizedTab = tab && typeof tab === 'object' ? tab : {};
      var key = normalizedTab.key || ('tab-' + index);
      var label = normalizedTab.label || key;
      var disabled = normalizedTab.disabled === true;
      var isActive = key === activeKey;

      return m('div', {
        key: key,
        class: 'ba b--mid-gray br2 ph2 pv1 pointer' +
          (index < tabs.length - 1 ? ' mr2' : '') +
          (isActive ? ' bg-mid-gray near-white' : '') +
          (disabled ? ' o-50' : ''),
        onclick: function () {
          if (disabled) return;
          onSelect(key);
        }
      }, label);
    }));
  }
};
